<script setup lang="ts">
import '@/index.css';
import 'floating-vue/dist/style.css';
import '@vuepic/vue-datepicker/dist/main.css';
import 'v-calendar/style.css';

import * as Sentry from "@sentry/vue";
import Front, { SingleConversationContext } from "@frontapp/plugin-sdk";
import { useContextStore, useClaimStore } from '@/store';
import { validate as uuidValidate } from 'uuid';

import NotificationGroup from '@/components/ui/notifications/NotificationGroup.vue';
import router from '@/router';
import { extractUUIDsFromString } from './utils';


/** Update store on conversation change */
Front.contextUpdates.subscribe(async (newContext) => {
  const contextStore = useContextStore();
  const claimStore = useClaimStore();

  contextStore.platform = 'front';

  const { email, username, name: fullName, id: frontId } = newContext.teammate;
  Sentry.setUser({ email, username });
  contextStore.user = { email, fullName, frontId };

  if (newContext.type === 'singleConversation') {
    contextStore.isOrphanConversation = false;
    const context = newContext as SingleConversationContext;
    contextStore.frontContext = context;

    const adminLinkBaseUrl = "https://admin.upclaim.eu/claims/";
    const adminLink = newContext.conversation.links.find(l => l.externalUrl.startsWith(adminLinkBaseUrl)
      || l.name?.startsWith(adminLinkBaseUrl) // Need to keep this for a few month
    );

    if (adminLink) {
      const [claimId] = extractUUIDsFromString(adminLink.externalUrl)
      if (uuidValidate(claimId)) {
        claimStore.retrieveClaim(claimId)
        router.push({ name: 'ClaimOverview', params: { id: claimId } })
        await contextStore.storeFrontMessages(context);
        console.log("!!! ok flow normal")
      }
    } else {
      claimStore.claim = null as any;
      contextStore.isOrphanConversation = true;
    }
  }
});
</script>

<template>
  <div class="min-h-screen bg-white">
    <NotificationGroup class="z-50" />
    <main>
      <router-view></router-view>
    </main>
  </div>
</template>
